<script setup lang="ts">
import { computed, ref, useTemplateRef, watch } from 'vue';
import { useRoute } from 'vue-router';
import VSpinner from '@shared/component/VSpinner/VSpinner.vue';
import VPageContainer from '@shared/layout/VPageContainer/VPageContainer.vue';
import { useClassicEmbedReset } from '@crm-lib/composables/useClassicEmbedReset';

const route = useRoute();

const title = computed(() => route.meta.label as string);
const pagina = computed(() => route.meta.pagina as string);
const iframeUrl = computed(() =>
  Object.entries(route.params).reduce(
    (url, [param, value]) =>
      url.replaceAll(`:${param}`, encodeURIComponent(Array.isArray(value) ? value[0] : value)),
    pagina.value,
  ),
);

const isLoading = ref<boolean>(true);
const iframeRef = useTemplateRef<HTMLIFrameElement>('iframeRef');

watch(iframeUrl, () => {
  isLoading.value = true;
});

function resetIframe() {
  if (!iframeRef.value) return;
  isLoading.value = true;
  iframeRef.value.src = iframeUrl.value;
}

const { onReset } = useClassicEmbedReset();

onReset(() => {
  resetIframe();
});
</script>
<template>
  <VPageContainer container-size="xl" :title="title" fit-content>
    <div
      class="size-full overflow-hidden rounded-md border border-solid border-grey-200 bg-white shadow-none"
    >
      <div class="flex size-full items-center justify-center text-3xl" v-if="isLoading">
        <VSpinner />
      </div>
      <iframe
        ref="iframeRef"
        v-show="!isLoading"
        title="pagina"
        class="size-full border-0 bg-white"
        :src="iframeUrl"
        @load="isLoading = false"
      ></iframe>
    </div>
  </VPageContainer>
</template>
